
import React from 'react';

const SocialProof = () => {
  // Híbrido: logos individuais com fallback para texto
  // Agora usando arquivos reais em /public/images/logo-clientes/
  const companies: { name: string; slug: string; alt: string; logo: string }[] = [
    { name: 'Hurbana', slug: 'hurbana', alt: 'Hurbana', logo: '/images/logo-clientes/Hurbana.png' },
    { name: 'Piemonte', slug: 'piemonte', alt: 'Piemonte', logo: '/images/logo-clientes/Piemonte.png' },
    { name: 'Naus', slug: 'naus', alt: 'Naus', logo: '/images/logo-clientes/Naus.png' },
    { name: 'CSETE', slug: 'csete', alt: 'CSETE', logo: '/images/logo-clientes/logo csete.png' },
    { name: 'Tauf', slug: 'tauf', alt: 'Tauf', logo: '/images/logo-clientes/Tauf.png' },
    { name: 'Grupo Estrutura', slug: 'grupo-estrutura', alt: 'Grupo Estrutura', logo: '/images/logo-clientes/Grupo%20Estrutura.png' },
    { name: 'Puel', slug: 'puel', alt: 'Puel', logo: '/images/logo-clientes/Puel.png' },
    { name: 'DCampos', slug: 'dcampos', alt: 'DCampos', logo: '/images/logo-clientes/DCampos.png' },
    { name: 'Lumma', slug: 'lumma', alt: 'Lumma', logo: '/images/logo-clientes/Lumma.png' },
    { name: 'Rodon', slug: 'rodon', alt: 'Rodon', logo: '/images/logo-clientes/Rodon.png' },
    { name: 'SBJ', slug: 'sbj', alt: 'SBJ', logo: '/images/logo-clientes/SBJ.png' },
  ];

  return (
    <section className="py-16 md:py-20 bg-white border-y border-border">
      <div className="container px-4 mx-auto">
        <div className="text-center space-y-8">
          <p className="text-sm font-semibold text-brand-azul/60 uppercase tracking-wider">
            Quem constrói com a dgenny
          </p>

          {/* Slider de Logos (marquee infinito, sem dependências) */}
          <div className="dgenny-marquee rounded-2xl bg-brand-azul py-10">
            <div className="dgenny-track px-6">
              {[...companies, ...companies].map((company, index) => (
                <div key={`${company.slug}-${index}`} className="flex items-center justify-center">
                  <img
                    src={company.logo}
                    alt={company.alt}
                    className="dgenny-logo"
                    onError={(e) => {
                      const target = e.currentTarget as HTMLImageElement;
                      target.onerror = null;
                      target.style.display = 'none';
                      const fallback = document.createElement('span');
                      fallback.className = 'text-sm font-semibold text-white/80';
                      fallback.textContent = company.name;
                      target.parentElement?.appendChild(fallback);
                    }}
                  />
                </div>
              ))}
            </div>
          </div>

          {/* Visual Element (optional image) */}
          {/*
            To display the logos image, add the file at public/images/company-logos.jpg
            and uncomment the block below. Keeping styling consistent with project.
          */}
          {false && (
            <div className="max-w-4xl mx-auto mt-8">
              <img
                src="/images/company-logos.jpg"
                alt="Empresas que confiam na DGenny"
                className="w-full h-32 object-cover rounded-lg opacity-60"
              />
            </div>
          )}
        </div>
      </div>
      {/* CSS escopado do slider */}
      <style>{`
        .dgenny-marquee { overflow: hidden; position: relative; }
        .dgenny-track { display: flex; gap: 2.5rem; align-items: center; width: max-content; animation: dgenny-scroll 28s linear infinite; }
        .dgenny-marquee:hover .dgenny-track { animation-play-state: paused; }
        @keyframes dgenny-scroll {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
        .dgenny-logo { height: 44px; max-width: 180px; object-fit: contain; filter: brightness(0) invert(1); opacity: 0.85; transition: opacity 200ms ease; }
        @media (min-width: 768px) { .dgenny-logo { height: 56px; } }
        .dgenny-logo:hover { opacity: 1; }
      `}</style>
    </section>
  );
};

export default SocialProof;

